import {defineStore} from "pinia";
import {createBaseStore} from "@/stores/base";

export const useMassStore = defineStore('mass', createBaseStore('/messen/',
        {
            currentSort: [
                {col: 'datetime', sortDir: 'desc'}
            ]
        },
        {
            async bulkCreateMasses(massBulkData) {
                try {
                    await this.axios.post(`/messen/bulk/`, massBulkData);
                    await this.getData();
                } catch (e) {
                    console.log(e);
                }
            },
        },
        {
            getMassIdsInPeriod: (state) => {
                return (startDate, endDate) => {
                    return state.data.filter(m => m.datetime.split('T')[0] >= startDate && m.datetime.split('T')[0] <= endDate).map(a => a.id);
                }
            },
            getMassStringById: (state) => {
                return (id) => {
                    return state.data.find(m => m.id === id).datetime;
                }
            },
        }
    )
)